import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import App_data from '../config/App_data';
import FD from '../RestAPI/fetchData';
import language from '../../assets/languages/language';
import { _getProfile } from '../../common/function';
/* eslint-disable*/
const fileTypes = ['jpg', 'jpeg', 'png', 'what', 'ever', 'you', 'want'];

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      oldPass: '',
      newPass: '',
      repeatPass: '',
      social: false,
      ValidToken: false,
      message: '',
      message_display_box: 'hide_block',

      token: '',
      idname: '',
      selectedMenu: this.props.params.selectedMenu,
      username: this.props.params.username,
    };
    this.oldPassChanged = this.oldPassChanged.bind(this);
    this.newPassChanged = this.newPassChanged.bind(this);
    this.repeatPassChanged = this.repeatPassChanged.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  oldPassChanged(e) {
    this.setState({
      oldPass: e.target.value,
    });
  }
  newPassChanged(e) {
    this.setState({
      newPass: e.target.value,
    });
  }
  repeatPassChanged(e) {
    this.setState({
      repeatPass: e.target.value,
    });
  }

  updatePassword() {
    if (this.state.oldPass == '') {
      this.setState({ message_display_box: 'show_block' });
      this.setState({ message: `${language.LC().Password_is_Required}` });
      return;
    }
    if (this.state.newPass == '') {
      this.setState({ message_display_box: 'show_block' });
      this.setState({ message: `${language.LC().New_Password_Is_Required}` });
      return;
    }
    if (this.state.repeatPass == '') {
      this.setState({ message_display_box: 'show_block' });
      this.setState({
        message: `${language.LC().Confirm_Password_is_Required}`,
      });
      return;
    }
    if (this.state.newPass != this.state.repeatPass) {
      this.setState({ message_display_box: 'show_block' });
      this.setState({
        message: `${language.LC().Password_And_Confirm_Password_Is_Required}`,
      });
      return;
    }

    if (this.state.newPass.length < 5) {
      this.setState({ message_display_box: 'show_block' });
      this.setState({
        message: `${language.LC().Please_enter_atleast_6_characters_in_the_field}`,
      });
      return;
    } else {
      this.setState({ message_display_box: 'hide_block' });
      var data = {
        idname: this.state.idname,
        oldpassword: this.state.oldPass,
        newpassword: this.state.newPass,
      };
      FD.callAPI(App_data.backend_api + '/user/updatePassword', data).then(resp => {
        if (resp.success) {
          this.setState({ message_display_box: 'show_block' });
          this.setState({ message: resp.message });
          this.setState({ oldPass: '', newPass: '', repeatPass: '' });
        } else {
          this.setState({ message_display_box: 'show_block' });
          this.setState({ message: resp.message });
        }
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        if (resp.profileInfo.password === null) {
          this.context.router.push({
            pathname: '/profile/',
            state: {
              token: storage_session['token'],
              idname: storage_session['idname'],
              selectedMenu: localStorage.getItem('selectedmenu'),
            },
          });
        }
      } else {
        browserHistory.push('/login');
      }
    });
  }

  togglepassword = val => {
    if (this.state.inputValue == val) this.setState({ inputValue: undefined });
    else this.setState({ inputValue: val });
  };

  render() {
    /*alert(localStorage.getItem('selectedmenu'));*/
    var validRender = (
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className='card-header'>
              {language.LC().CHANGE_PASSWORD}
              <div className='card-actions float-md-right'>
                <span
                  className='text_light cursor_pointer'
                  onClick={_getProfile.bind(this, this.state.username)}
                >
                  {language.LC().GO_TO_PROFILE} &nbsp;&nbsp;&nbsp;{' '}
                  <img src={App_data.frontend_url + '/img/arrow_right.png'} className='' alt='' />
                </span>
              </div>
            </div>
            <div className='card-block'>
              <div className='padding_top_60 padding_bottom_60'>
                <div className='row'>
                  <div className='col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4'>
                    <div className='form_wrapper'>
                      <div className='row'>
                        <div className={'col-sm-12 ' + this.state.message_display_box}>
                          <p className='error_text'>
                            <strong>{this.state.message}</strong>
                          </p>
                        </div>
                        <div className='col-sm-12'>
                          <div className='form_field'>
                            <label> {language.LC().OLD_PASSWORD} </label>
                            <div className='input-group'>
                              <span className='input-group-addon'>
                                {/*<i className="fa fa-user"></i>*/}
                                <img
                                  src={App_data.frontend_url + '/img/profile/lock_icon.svg'}
                                  className=''
                                  width='15'
                                  alt=''
                                />
                              </span>
                              <input
                                type={this.state.inputValue == 1 ? 'text' : 'password'}
                                id='input1-group1'
                                name='input1-group1'
                                className='form-control'
                                placeholder='Old password'
                                value={this.state.oldPass}
                                disabled={this.state.social}
                                onChange={this.oldPassChanged}
                              />
                              {this.state.inputValue == 1 ? (
                                <img
                                  onClick={() => this.togglepassword('1')}
                                  src={App_data.frontend_url + '/img/show 2.png'}
                                  alt=''
                                />
                              ) : (
                                <img
                                  onClick={() => this.togglepassword('1')}
                                  src={App_data.frontend_url + '/img/hide2.png'}
                                  alt=''
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-sm-12'>
                          <div className='form_field'>
                            <label> {language.LC().NEW_PASSWORD} </label>
                            <div className='input-group'>
                              <span className='input-group-addon'>
                                {/*<i className="fa fa-user"></i>*/}
                                <img
                                  src={App_data.frontend_url + '/img/profile/lock_icon.svg'}
                                  className=''
                                  width='15'
                                  alt=''
                                />
                              </span>
                              <input
                                type={this.state.inputValue == 2 ? 'text' : 'password'}
                                id='input1-group1'
                                name='input1-group1'
                                className='form-control'
                                placeholder='New password'
                                value={this.state.newPass}
                                disabled={this.state.social}
                                onChange={this.newPassChanged}
                              />
                              {this.state.inputValue == 2 ? (
                                <img
                                  onClick={() => this.togglepassword('2')}
                                  src={App_data.frontend_url + '/img/show 2.png'}
                                  alt=''
                                />
                              ) : (
                                <img
                                  onClick={() => this.togglepassword('2')}
                                  src={App_data.frontend_url + '/img/hide2.png'}
                                  alt=''
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-sm-12'>
                          <div className='form_field'>
                            <label> {language.LC().CONFIRM_NEW_PASSWORD} </label>
                            <div className='input-group'>
                              <span className='input-group-addon'>
                                {/*<i className="fa fa-user"></i>*/}
                                <img
                                  src={App_data.frontend_url + '/img/profile/lock_icon.svg'}
                                  className=''
                                  width='15'
                                  alt=''
                                />
                              </span>
                              <input
                                type={this.state.inputValue == 3 ? 'text' : 'password'}
                                id='input1-group1'
                                name='input1-group1'
                                className='form-control'
                                placeholder='Confirm password'
                                value={this.state.repeatPass}
                                disabled={this.state.social}
                                onChange={this.repeatPassChanged}
                              />
                              {this.state.inputValue == 3 ? (
                                <img
                                  onClick={() => this.togglepassword('3')}
                                  src={App_data.frontend_url + '/img/show 2.png'}
                                  alt=''
                                />
                              ) : (
                                <img
                                  onClick={() => this.togglepassword('3')}
                                  src={App_data.frontend_url + '/img/hide2.png'}
                                  alt=''
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-sm-12'>
                          <div className='border_line' />
                        </div>
                        <div className='col-sm-12'>
                          <button
                            className='btn btn-primary btn_full_width'
                            onClick={this.updatePassword.bind(this)}
                          >
                            {' '}
                            {language.LC().UPDATE_PASSWORD}{' '}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    if (this.state.ValidToken) return validRender;
    else return <p />;
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/views/ChangePassword/ChangePassword.js